import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../../config';
import { useDueDate } from '../../contexts/dueDateContext';
import apiServicewt from '../../api/apiServicewt';

const DueDateStatusLoader = ({ setShowOverlay, setErrorCode, setIsTrial, setIsTrialDate }) => {
	const { setDueDateStatus, setReqStatus, setRemainingDays } = useDueDate();
	const navigate = useNavigate();

	useEffect(() => {
		const fetchServices = async () => {
			setReqStatus('loading');

			const item = { action: 'check_status' };
			try {
				const config = getConfig();
				const flechdata = await apiServicewt(item, navigate);

				if (typeof setIsTrial === 'function') {
					setIsTrial(flechdata.is_trial);
				}
				if (typeof setIsTrialDate === 'function') {
					setIsTrialDate(flechdata.trial_days_left);
				}

				// if (typeof setIsTrial === 'function') {
				// 	setIsTrial(flechdata.is_trial);
				//
				// }
				// if (typeof setIsTrialDate === 'function') {
				// 	setIsTrialDate(flechdata.trial_days_left);
				//
				// }

				if (flechdata.type === 'error') {
					setReqStatus('error');
					if (typeof setShowOverlay === 'function') {
						setShowOverlay(true);
					}
					if (typeof setErrorCode === 'function') {
						setErrorCode(flechdata.error_code);
					}
					return;
				}

				setReqStatus('success');

				if (flechdata.customer_link) {
					config.REACT_APP_REDIRECT_CUSTOMER_LINK = flechdata.customer_link;
				}
				if (flechdata.employee_link) {
					config.REACT_APP_REDIRECT_EMPLOYEE_LINK = flechdata.employee_link;
				}

				if (!flechdata.billing_date) {
					return;
				}

				const billingDate = new Date(flechdata.billing_date);
				const currentDate = new Date();

				const billingDateMinus14 = new Date(billingDate);
				billingDateMinus14.setDate(billingDateMinus14.getDate() - 3);

				let status;
				let remainingDays = null;

				if (
					billingDateMinus14.getTime() <= currentDate.getTime() &&
					currentDate.getTime() <= billingDate.getTime()
				) {
					status = 'WARNING';
				} else if (currentDate.getTime() > billingDate.getTime()) {
					status = 'INVALID';

					const graceEndDate = new Date(billingDate);
					graceEndDate.setDate(graceEndDate.getDate() + 10);

					const diffInMs = graceEndDate.getTime() - currentDate.getTime();
					const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

					remainingDays = diffInDays > 0 ? diffInDays : 0;
				} else {
					status = 'VALID';
				}

				config.REACT_APP_DUE_DATE_STATUS = status;
				setDueDateStatus(status);
				setRemainingDays(remainingDays);
			} catch (error) {
				setReqStatus('error');
				console.error('Error fetching services:', error);
			}
		};

		fetchServices();
	}, [navigate, setShowOverlay, setDueDateStatus, setReqStatus, setRemainingDays]);

	return null;
};

export default DueDateStatusLoader;
